import * as React from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';
import { useFluxible } from '../hooks/useFluxible';
import styles from './styles.module.styl';
export var Pagination = function (_a) {
    var _b = _a.activePage, activePage = _b === void 0 ? 1 : _b, pageCount = _a.pageCount, onChange = _a.onChange;
    var context = useFluxible();
    var onSelect = function (page) {
        onChange(page);
    };
    return (React.createElement("div", { className: styles.paginationContainer },
        React.createElement(BootstrapPagination, { prev: activePage > 1 && '‹ Previous', next: activePage < pageCount && 'Next ›', first: activePage > 1 && '« First', last: activePage < pageCount && 'Last »', items: pageCount, maxButtons: 10, ellipsis: false, activePage: activePage, onSelect: onSelect }),
        React.createElement("div", null,
            "Didn't find what you are looking for?\u00A0\u00A0",
            React.createElement("a", { href: "https://community.auth0.com/", onClick: function () { return context.trackEvent('click:view-community'); }, target: "_blank", rel: "noreferrer noopener" }, "Ask the Auth0 Community"))));
};
